module.exports = __webpack_public_path__ + "img/deliveryscooter.bfc64f9c.svg";